<template>
    <bottom-sheet v-model="shows" title="근로계약 퇴근하기" fullscreen persistent width="720" maxWidth="100%">
        <template #activator="bind">
            <slot name="activator" v-bind="bind" />
        </template>
        <v-layout column justify-center class="fill-height">
            <init-tabs v-model="tab" v-slot="{ prev, next }">
                <!-- 기본 입력 -->
                <tabs-scan
                    v-model="form"
                    v-bind="{
                        tab,
                        shows,
                        loading,
                    }"
                    v-on="{
                        exit,
                        next,
                        setLoading,
                        input: emit,
                    }"
                />
                <!-- 필드 입력 -->
                <tabs-form
                    v-model="form"
                    v-bind="{
                        tab,
                        shows,
                        loading,
                        saveText: '퇴근 하기',
                    }"
                    v-on="{
                        prev,
                        save,
                        setLoading,
                        input: emit,
                    }"
                />
            </init-tabs>
        </v-layout>
        <client-loader v-bind="{ loading }" />
    </bottom-sheet>
</template>

<script>
import api from "@/api";
import { TABS } from "./init/lib";
import { ATTENDANCE_LOG_TYPES, initAttendanceLog } from "@/store/attendance";

import BottomSheet from "@/components/dumb/bottom-sheet.vue";
import ClientLoader from "@/components/client/dumb/client-loader.vue";
import InitTabs from "./init/init-tabs.vue";
import TabsForm from "./init/tabs/tabs-form.vue";
import TabsScan from "./init/tabs/tabs-scan.vue";

export default {
    components: {
        BottomSheet,
        ClientLoader,
        InitTabs,
        TabsForm,
        TabsScan,
    },
    props: {
        value: { type: Object, default: () => initAttendanceLog({ type: ATTENDANCE_LOG_TYPES.DONE.value }) },
    },
    data: () => ({
        tab: TABS.SCAN.value,
        form: initAttendanceLog({ type: ATTENDANCE_LOG_TYPES.DONE.value }),

        shows: false,
        loading: false,
    }),
    computed: {
        isCreate() {
            return !this.value?._id;
        },
    },
    methods: {
        async init() {
            this.tab = TABS.SCAN.value;
            this.loading = false;
            this.form = initAttendanceLog(this.value);
        },

        async save() {
            if (this.loading) return;
            else this.loading = true;

            try {
                let { ...form } = this.form;
                let { log } = await api.v1.person.attendance.logs.post(form);

                this.form = initAttendanceLog(log);
                this.$emit("input", log);
                this.$emit("search");
                alert("퇴근 처리되었습니다");
                this.shows = false;
            } finally {
                this.loading = false;
            }
        },

        setLoading(loading) {
            this.loading = loading;
        },

        emit() {
            this.form = initAttendanceLog(this.form);
        },

        exit() {
            this.shows = false;
        },
    },
    watch: {
        shows() {
            if (this.shows) this.init();
        },
    },
};
</script>

<style lang="scss" scoped>
::v-deep {
    .text-right input {
        text-align: right;
    }
    .v-input--switch label {
        margin-bottom: 4px;
    }
    .v-textarea textarea {
        margin: 0 !important;
        padding-top: 8px;
        line-height: 1.875em;
    }
}
</style>
